import {apiPOST} from "./RequestsCore";

/**
 * Sends an API request to transform the raw HTML with shortcodes to a processed HTML with those shortcodes translated into data.
 *
 * @param html_content
 * @param params
 * @returns {Promise<null|T>}
 */
export async function parseHTML(html_content, params) {
    let data = {
        html: html_content
    }
    for (let i in params) {
        data[i] = params[i];
    }

    return await apiPOST('/api/html/parse', data);
}
